import { Color } from '@visiba/std';

type RgbTuple = [number, number, number];

export function variableToHex(variableName: string): string {
	// TODO: Figure out if there's a better way to compute hex from variable
	if (variableName.startsWith('var')) {
		variableName = variableName.substring(4, variableName.length - 2);
	}

	return getComputedStyle(document.documentElement).getPropertyValue(variableName).trim();
}

export function variableToRgb(variableName: string): RgbTuple {
	const hex = variableToHex(variableName);
	if (!hex) return [0, 0, 0];

	const [r, g, b, _] = Color.createRgb(hex);

	return [r, g, b];
}
